import chroma from "chroma-js";

const scale = chroma.scale(["#e74c3c", "#f1c40f", "#c9e383"]);

export function getColorForUptime(uptime: number | undefined | null) {
  if (uptime === undefined || uptime === null) return "#e5e5e5";
  if (uptime === 100) return "#2ecc71";
  return scale(uptime / 100).toString();
}
